import { getDateFormat } from 'helpers/dates'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import ListFromTable from 'components/common/ListFromTable'
import {
  translationsJobWorkflowInputFetchTableData,
  translationsJobWorkflowInputClearStateList,
} from 'reducers/translations/jobWorkflowInput/reducer'
import * as ROUTE from 'constants/appRouting'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import Sort from 'lib/psfs/Sort'
import messages from './translate'

class JobWorkflowInputList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.translationsJobWorkflowInputFetchTableData
    this.clearReducerState = props.translationsJobWorkflowInputClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (this.props.tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.jobWorkflowInputList),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
      licensee: { usaDateFormat },
    } = this.props
    const columns = new ColumnCollection()
    const dateDisplay = getDateFormat(usaDateFormat)

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('title', formatMessage(messages.title), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('dateUpdated', formatMessage(messages.dateUpdated), {
        sorting: true,
        render: row => moment(row.dateUpdated).format(dateDisplay),
      }),
    )

    return columns
  }

  getActions() {
    const {
      intl: { formatMessage },
      history,
    } = this.props
    const actions = new ActionCollection()

    actions.add(
      new Action('edit', formatMessage(messages.edit), ({ id }) => {
        history.push(
          UrlHelper.create(ROUTE.TRANSLATIONS_JOB_WORKFLOW_INPUT_EDIT, { id }),
        )
      }),
    )

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['jobWorkflowInputTranslations', 'tableData']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    translationsJobWorkflowInputFetchTableData,
    translationsJobWorkflowInputClearStateList,
  },
)(injectIntl(JobWorkflowInputList))
